import { getBrands, getInterests, getLocations, getTopics } from "../api/instagram";

export const fetchData = async (apiCall, params) => {
  try {
    const response = await apiCall(params);
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw new Error('Failed to fetch data. Please try again.');
  }
}

export const fetchInterests = async (query) => {
  const data = await fetchData(getInterests, { query });
  return data;
}

export const mapInterests = (data) =>
  data?.interests?.map((interest) => ({
    value: interest.id,
    label: interest.name,
  })) || [];

export const fetchLocations = async (query) => {
  const data = await fetchData(getLocations, { query });
  return data;
}

export const mapLocations = (data) =>
  data?.locations?.map((location) => ({
    value: location.id,
    label: location.title,
  })) || [];

export const fetchTopics = async (query) => {
  const data = await fetchData(getTopics, { query });
  return data;
}

export const mapTopics = (data) =>
  data?.tags?.map((tag) => ({
    value: tag,
    label: `#${tag}`,
  })) || [];

export const fetchBrands = async (query) => {
  const data = await fetchData(getBrands, { query });
  return data;
}

export const mapBrands = (data) =>
  data?.brands?.map((brand) => ({
    value: brand.id,
    label: brand.name,
  })) || [];
